import CryptoJS from "crypto-js"
import axios from "axios"

class Upload {
  constructor(options) {
    this.options = options
    this.id = "upload_" + Math.random().toString(36).substr(2, 9)
  }

  start(file) {
    this.file = file
    this.uploaded = false
    this.saved = false
    return new Promise((resolve, reject) => this.process(file, resolve, reject))
  }

  process(file, resolve, reject) {
    const domId = this.id
    this.readFileBinary(file)
      .then(reader => this.uploadFile(file, reader))
      .then(result => this.saveFile(result))
      .then(result => result.json())
      .then(result => resolve({ id: this.id, json: result }))
      .catch(error => reject({ id: this.id, error: error }))
  }

  readFileBinary(file) {
    const reader = new FileReader()
    return new Promise((resolve, reject) => {
      reader.onload = () => resolve(reader)
      reader.onerror = () => reject(reader)
      reader.readAsBinaryString(file)
    })
  }

  async uploadFile(file, reader) {
    const md5      = CryptoJS.MD5(CryptoJS.enc.Latin1.parse(reader.result))
    const checksum = md5.toString(CryptoJS.enc.Base64)
    const details  = await this.uploadDetails(file.name, file.type, checksum)
    return axios.put(details.url, file, {
      headers: details.headers,
      onUploadProgress: event => this.uploadProgress(event),
    })
  }

  async uploadDetails(filename, filetype, checksum) {
    const params = new URLSearchParams({ 
      name: filename, 
      type: filetype, 
      checksum: checksum,
    })
    return await fetch(this.options.presignUrl + "?" + params).then(result => result.json())
  }

  saveFile(result) {
    return new Promise((resolve, reject) => {
      if (result.status == 200) {
        fetch(this.options.documentsUrl, this.saveDetails(result))
          .then(result => {
            this.saved = true
            this.overallProgress()
            resolve(result)
          })
          .catch(error => reject(error))
      } else {
        reject(result)
      }
    })
  }

  saveDetails(result) {
    const url = new URL(result.request.responseURL)
    const token = document.getElementsByName("csrf-token")[0].content
    return {
      method: this.options.documentsMethod || "POST",
      body: JSON.stringify({
        document: {
          file: {
            id: url.pathname.split("/").at(-1),
            storage: `${this.options.storage}_cache`, //"cache"
            metadata: {
              size:      result.config.data.size,
              filename:  result.config.data.name,
              mime_type: result.config.data.type,
            },
          }
        }
      }),
      headers: { "Content-Type": "application/json", "X-CSRF-Token": token },
      credentials: "same-origin",
    }
  }

  uploadProgress(event) {
    if (event.loaded == event.total) {
      this.uploaded = true
      this.overallProgress()
    } else {
      this.uploaded = false
      this.overallProgress({ 
        progress: Math.round(event.loaded / event.total * 100)
      })
    }
  }

  overallProgress(options) {
    if (!this.options.callback) return
    let status
    if (this.saved) {
      status = { id: this.id, uploaded: true, saved: true, progress: 100 }
    } else if (this.uploaded) {
      status = { id: this.id, uploaded: true, saved: false, progress: 100 }
    } else if (options.progress) {
      status = { id: this.id, uploaded: false, saved: false, progress: options.progress }
    } else if (options.image) {
      status = { id: this.id, uploaded: false, saved: false, progress: 0 }
    }
    this.options.callback(status, this.options.controller)
  }
}

export { Upload }